module.exports = __webpack_public_path__ + "media/src/assets/icon-8954d722288f0915503205e71b49af51.png";